import { Component, signal, output, Input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'base-outline-button-sm',
  templateUrl: './outline-button-sm.component.html',
  styleUrls: ['./outline-button-sm.component.scss'],
  imports: [CommonModule]
})
export class OutlineButtonSmComponent {

  private _isSecondaryBtnStyle = signal(false);
  private _loading = signal(false);
  private _disabled = signal(false);

  @Input() set isSecondaryBtnStyle(value: boolean) {
    this._isSecondaryBtnStyle.set(value);
  }
  get isSecondaryBtnStyle() {
    return this._isSecondaryBtnStyle();
  }

  @Input() set loading(value: boolean) {
    this._loading.set(value);
  }
  get loading() {
    return this._loading();
  }

  @Input() set disabled(value: boolean) {
    this._disabled.set(value);
  }
  get disabled() {
    return this._disabled();
  }

  readonly isButtonDisabled = computed(() => this._loading() || this._disabled());

  // Update output to use Angular 20 output() function
  buttonClicked = output<boolean>();

  onButtonClick() {
    if (!this.isButtonDisabled()) {
      this.buttonClicked.emit(true);
    }
  }
}

